import { useEffect } from "react";

export default function useAutoScroll({
    currentQuestionIndex,
    visibleQuestions,
    answers,
    currentQuestionRef,
    messagesEndRef,
}) {
    // Disabled: scroll behavior is now handled in intake.jsx to ensure Continue button visibility
    // The scroll logic in intake.jsx uses inputWrapperRef instead of currentQuestionRef
    // to ensure both the question AND the Continue button are always visible

    // When answers change, scroll to bottom
    useEffect(() => {
        messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
    }, [answers, messagesEndRef]);
}
